import styled from "styled-components";


export const NonProfitMessage = styled.div`
    width: 100%;
    min-width: 282px;
    background: #FFFFFF; 
    border: 1px solid #000000;
    border-radius: 15px;
    padding: 20px;
    text-align: left;

    @media screen and (max-width: 1200px){
        min-width: 100%;
    }
    
    button{
        background: #016B7B;
        width: 100%;
        font-size: 16px;    
        font-family: 'Jost', sans-serif;
        font-weight: 500;
        line-height: 22px;
        color: #FFFFFF;
        padding: 13px 20px;
        border-radius: 10px;
        margin-top: 15px;
        border: none;
        box-shadow: 3px 5px 20px #00000033;
        transition: 0.25s ease all;
    }
    button:hover{
        background: #ffd495;
        color: #000;
    }
`;

export const NonProfitMessageTitle = styled.h3`
    color: #333333;
    font-size: 20px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 30px;
    margin-bottom: 15px;
`;

export const MessageImg = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-item: flex-start;
    column-gap: 10px;

    img{
        width: 44px;
        height: 44px;
        display: block;
    }
`;

export const NonProfitMessText = styled.div`
    color: rgb(51 51 51 / 80%);
    font-size: 14px;
    font-family: 'Metropolis', sans-serif;
    font-weight: 400;
    line-height: 20px
`;

export const GetOurLatestNewsWrap = styled.div`
    width: 100%;
    display: flex;
    margin-bottom: 20px;
    form{
        .input-group{
            flex-direction: column;
            row-gap: 10px;

            .form-control{
                padding: 10px 20px !important;
                font-weight: 400;
            }
            input::placeholder{
                color: rgb(0 0 0 / 50%);
            }
        }
        .input-group-checkbox{
            margin-bottom: 15px;
            flex-direction: column; 
            align-items: flex-start;
        }
    }
    .form-check-input{
        &:focus{
            box-shadow: none;   
            border-color: none;
        }
    }
`;